/* Ixaria — configurator as an in-page overlay
   ---------------------------------------------------------------------------
   Opening the configurator used to be a page navigation, so the engine started
   from nothing every time. Three lighter approaches were tried and none of them
   can make it instant:

     prefetching   removes the download, but the new document still re-parses
                   the 2.7MB bundle and reloads the product
     an iframe     Shopify serves the storefront with X-Frame-Options: DENY, so
                   the shop cannot embed itself even same-origin
     prerendering  Chromium throttles work in prerendered documents, and a WebGL
                   scene is exactly what it defers until activation

   So the configurator is rendered into the product page itself, hidden, and its
   engine is started once the page has settled. Opening it is then a CSS class
   change on markup that has already drawn.

   This is only possible because the two ported scripts no longer collide: the
   configurator's 42 shared top-level names carry a cfg_ prefix. Without that,
   whichever loaded second would clobber the other.

   Needs window.IX_PDP.figaro = { bundleUrl, overlay: true }. */

(function () {
  var CFG = (window.IX_PDP && window.IX_PDP.figaro) || {};
  var root = document.getElementById('ix-cfg');
  if (!root || !CFG.overlay) return;

  var booted = false;

  function connectionIsCheap() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return true;
    if (c.saveData) return false;
    if (c.effectiveType && /(^|\W)(slow-)?2g|3g/.test(c.effectiveType)) return false;
    return true;
  }

  /* The engine and the configurator's own behaviour are only pulled in once the
     product page has finished its own work, so this never competes with it. */
  var onBoot = [];
  function whenBooted(fn) {
    if (booted) fn();
    else onBoot.push(fn);
  }
  function boot() {
    if (booted) return;
    booted = true;
    onBoot.splice(0).forEach(function (fn) { fn(); });

    var scripts = [CFG.bundleUrl, CFG.configuratorJs, CFG.bridgeJs].filter(Boolean);
    (function next(i) {
      if (i >= scripts.length) return;
      var el = document.createElement('script');
      el.src = scripts[i];
      /* The engine ships as a module; the other two are plain scripts. */
      if (scripts[i] === CFG.bundleUrl) el.type = 'module';
      el.onload = el.onerror = function () { next(i + 1); };
      document.head.appendChild(el);
    })(0);
  }

  /* Motorul pornit la cerere, pentru poza facuta fara configurator
     (ixaria-pdp.js, cand clientul alege alta forma in pagina): clientul
     lucreaza chiar acum cu formele, deci nu se mai asteapta sa se linisteasca
     pagina. Nu si pe o conexiune scumpa, unde motorul nu porneste nici singur.
     Spune daca motorul e (sau va fi) pornit. */
  window.ixCfgWarm = function () {
    if (!booted && !connectionIsCheap()) return false;
    boot();
    return true;
  };

  /* Butoanele care duc intr-o anumita sectiune a configuratorului. Prin
     navigare, tinta calatorea in hash (`...?view=ixaria-configurator#color`) si
     configuratorul o citea la initializare. Overlay-ul insa opreste navigarea,
     deci hash-ul nu mai ajunge nicaieri si se deschidea mereu la inceput.
     Harta asta tine aceleasi tinte pe care le au butoanele in onclick.

     'color' este sectiunea #sec-color, adica „Alege materialul".

     „Configureaza" (#hero-conf) tinteste 'layout', chiar daca layout este
     prima sectiune si scrollCfgTo o duce la 0: panoul isi pastreaza pozitia
     intre deschideri, deci fara tinta o redeschidere ar cadea acolo unde a
     ramas data trecuta, nu la inceput. */
  var SECTION_FOR = {
    '#hero-conf': 'layout',
    '.wbtn': 'layout',
    '.btn-custom': 'layout',
    '.sw-plus': 'color',
    /* „Configurează cu acest material" (sectiunea de materiale): la colectia culorii (revealSwatch) */
    '.mx-cta': 'swatch'
  };

  function sectionFor(el) {
    for (var sel in SECTION_FOR) {
      if (Object.prototype.hasOwnProperty.call(SECTION_FOR, sel) && el.closest(sel)) {
        return SECTION_FOR[sel];
      }
    }
    return null;
  }

  /* Configuratorul se incarca lenes, deci scrollCfgTo() poate sa nu existe inca
     in clipa deschiderii, iar sectiunea poate sa nu fie randata. Se asteapta
     amandoua, cu un plafon ca sa nu se invarta la nesfarsit daca ceva a picat. */
  /* Cat dureaza drumul pana la sectiune. `behavior: smooth` nu se poate
     incetini — durata o alege browserul — deci derularea o facem noi, ca sa
     fie destul de lenta cat sa se vada unde te duce. */
  var SCROLL_MS = 900;
  /* „Configurează cu acest material": drumul pana la colectie e lung, deci 500ms in plus
     (cerut 2026-10-13: 900ms parea prea repede) */
  var SWATCH_SCROLL_MS = SCROLL_MS + 500;

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function glideTo(scroll, top, done, ms) {
    var dur = ms || SCROLL_MS;
    var from = scroll.scrollTop;
    var delta = top - from;
    if (Math.abs(delta) < 2) return done();
    /* Cine a cerut „fara miscare" din sistem sare direct. Inainte, regula asta
       statea in CSS (pe efectul de fundal, acum scos); derularea fiind acum
       facuta de noi, tot noi trebuie sa o respectam. */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      scroll.scrollTop = top;
      return done();
    }
    var t0 = null;
    var finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      scroll.scrollTop = top;
      done();
    }

    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      scroll.scrollTop = from + delta * easeInOutCubic(p);
      if (p < 1) requestAnimationFrame(step);
      else finish();
    }
    requestAnimationFrame(step);

    /* Plasa de siguranta: cadrele nu vin deloc intr-o fila din fundal (si nici
       in Chrome headless), iar atunci animatia nu ar porni niciodata si
       utilizatorul ar ramane in capul listei. Dupa ce drumul ar fi trebuit sa
       se termine, pozitia se pune direct. */
    setTimeout(finish, dur + 120);
  }

  function revealSection(sec) {
    var tries = 0;
    (function attempt() {
      var scroll = document.getElementById('cfg-scroll');
      var target = document.getElementById('sec-' + sec);
      /* scroll.clientHeight > 0 conteaza, nu doar existenta elementelor:
         panoul tocmai a fost dezvaluit, iar pana se aseaza, dreptunghiurile
         sunt zero — tinta ar iesi 0 si nu s-ar misca nimic. */
      if (scroll && target && scroll.clientHeight > 0 &&
          (typeof window.scrollCfgTo === 'function')) {
        /* Panoul isi pastreaza pozitia intre deschideri, deci se porneste de
           sus: altfel o redeschidere ar putea incepe deja langa tinta si nu
           s-ar vedea nicio miscare. */
        scroll.scrollTop = 0;

        setTimeout(function () {
          /* Chip-ul se aprinde de la inceput: el spune care sectiune e
             selectata cat timp deruleaza. */
          if (typeof window.setActiveCfgChip === 'function') {
            window.setActiveCfgChip(sec, true);
          }
          /* Aceeasi formula ca scrollCfgTo din configurator, INCLUSIV termenul
             SCROLL_SEC_PAD. Fara el, derularea se oprea cu 16px mai jos decat
             pozitia pe care o considera configuratorul corecta, iar apelul de
             la final o corecta brusc: exact saritura de dupa tranzitie.

             Si nu se mai cheama nimic dupa alunecare — orice repozitionare la
             final se vede ca un salt. Chip-ul e deja aprins de la inceput. */
          var pad = (window.SCROLL_SEC_PAD && window.SCROLL_SEC_PAD[sec]) || 0;
          var top = sec === 'layout' ? 0
            : Math.max(0, target.getBoundingClientRect().top
                - scroll.getBoundingClientRect().top + scroll.scrollTop - pad);
          glideTo(scroll, top, function () {});
        }, 16);
        return;
      }
      if (++tries < 60) setTimeout(attempt, 100);
    })();
  }

  /* „Configurează cu acest material" (sectiunea de materiale, .mx-cta; cerut 2026-10-13):
     configuratorul se deschide pe culoarea din pagina si deruleaza la colectia ei, cu titlul
     colectiei sus, iar placa aleasa la vedere (cand e mai jos de ecran, placa la mijloc).
     Placa (.mtile.on) e cea buna abia dupa ce bridge-ul aplica culoarea, deci se asteapta
     pana are numele din pagina (cel mult ~8s), apoi se cade pe „Alege culoarea". Pagina scrie
     codurile fara zero („Luna 5"), configuratorul cu („Luna 05"): se compara fara zerouri. */
  function normName(s) {
    return String(s || '').toLowerCase().replace(/\s+/g, ' ').replace(/\b0+(\d)/g, '$1').trim();
  }
  function revealSwatch(name) {
    var want = normName(name);
    var tries = 0;
    if (!want) return revealSection('colors-grid');
    (function attempt() {
      var scroll = document.getElementById('cfg-scroll');
      var tile = null;
      var on = document.querySelectorAll('#cfg-fabric-sections .mtile.on');
      for (var i = 0; i < on.length; i++) {
        if (normName(on[i].dataset.name) === want) {
          tile = on[i];
          break;
        }
      }
      if (scroll && tile && scroll.clientHeight > 0 && tile.offsetParent) {
        /* de sus, ca in revealSection: sa se vada drumul pana la colectie */
        scroll.scrollTop = 0;
        setTimeout(function () {
          if (typeof window.setActiveCfgChip === 'function') {
            window.setActiveCfgChip('colors-grid', true);
          }
          var pad = (window.SCROLL_SEC_PAD && window.SCROLL_SEC_PAD['colors-grid']) || 0;
          var base = scroll.getBoundingClientRect().top - scroll.scrollTop;
          var group = tile.closest('.cfg-matgroup-body') || tile;
          var top = group.getBoundingClientRect().top - base - pad;
          var tr = tile.getBoundingClientRect();
          var tileTop = tr.top - base;
          if (tileTop + tr.height + pad > top + scroll.clientHeight) {
            top = tileTop - (scroll.clientHeight - tr.height) / 2;
          }
          glideTo(scroll, Math.max(0, top), function () {}, SWATCH_SCROLL_MS);
        }, 16);
        return;
      }
      if (++tries < 80) setTimeout(attempt, 100);
      else revealSection('colors-grid');
    })();
  }

  function open(section) {
    boot();                                   /* no-op once warm */
    document.documentElement.classList.add('ix-cfg-open');
    root.setAttribute('aria-hidden', 'false');
    /* Hand over what the shopper picked on the product page. */
    var pick = {};
    try {
      var sw = document.querySelector('#pdp .sw.on');
      if (sw && sw.dataset.name) pick.colorName = sw.dataset.name;
      var shape = document.querySelector('#view-shape [data-name].on');
      if (shape && shape.dataset.name) pick.shapeName = shape.dataset.name;
    } catch (e) {}
    if (pick.colorName || pick.shapeName) {
      document.dispatchEvent(new CustomEvent('ixaria:overlay-open', { detail: pick }));
    }
    if (section === 'swatch') revealSwatch(pick.colorName);
    else if (section) revealSection(section);
  }

  /* „Adaugă în coș" din configurator, cu cosul ca pagina (cfg_addToCart): pagina cosului e
     deja pe drum, deci configuratorul ramane pe ecran pana il inlocuieste ea. Inchis intai,
     pagina produsului se vedea o clipa inainte de cos. Restul inchiderii (culoarea si forma
     mutate in pagina, adresa) s-a facut; daca clientul revine cu „Inapoi" si browserul reda
     pagina din memorie (bfcache), configuratorul se inchide pe loc, fara alunecare. */
  var leftForCart = false;
  function close(ev) {
    trackClose(ev);
    if (ev && ev.detail && ev.detail.toCartPage) {
      leftForCart = true;
      return;
    }
    leftForCart = false;
    document.documentElement.classList.remove('ix-cfg-open');
    root.setAttribute('aria-hidden', 'true');
  }
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted || !leftForCart) return;
    root.style.transition = 'none';
    close();
    void root.offsetWidth;
    root.style.transition = '';
  });

  /* Reveal instead of navigating. Capture phase, so this runs before the UI's
     own handler reaches pushTo().

     Fiecare intrare in configurator trebuie sa fie in lista asta. Butoanele
     care nu sunt aici cad pe pushTo(), adica o navigare adevarata: pagina se
     reincarca si motorul de 2.7MB se parseaza din nou — exact ce evita
     overlay-ul. Asa se comporta „Personalizează" din banda cu
     atelierul (.wbtn) pana acum.

     #typesel („Schimba") nu mai e aici: deschide selectorul de forma din
     pagina (openShapeSheet), nu configuratorul. */
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest &&
            ev.target.closest('#hero-conf, .sw-plus, .wbtn, .btn-custom, .mx-cta');
    if (!t || root.contains(t)) return;       /* ignore clicks inside the overlay */
    ev.preventDefault();
    ev.stopPropagation();
    open(sectionFor(t));
    if (ev.isTrusted) trackOpen(t);
  }, true);

  /* ── PostHog si Ixaria: deschiderea si inchiderea (cerut 2026-10-26; la Ixaria cu Ixaria.track
     de la 2026-10-27, la PostHog ca inainte) ──
     Ce face clientul inauntru trimite ixaria-configurator.js (cfg_track, acolo e si de ce).
     Vizita sta in window.ixCfgVisit: configuratorul numara in ea alegerile, rotirea / marirea
     modelului 3D si „Adaugă în coș". ixaria_custom_overlay_opened e numele din tema veche. */
  var SOURCE_FOR = {
    '#hero-conf': 'gallery',
    '.btn-custom': 'buy_box',
    '.sw-plus': 'more_colours',
    '.wbtn': 'workshop_band',
    '.mx-cta': 'materials_section'
  };
  /* Forma si culoarea din pagina: cu ele porneste configuratorul. */
  function pagePick() {
    var sw = document.querySelector('#pdp .sw.on');
    var shape = document.querySelector('#view-shape [data-name].on');
    return {
      shape_name: shape ? shape.dataset.name : null,
      colours: sw ? sw.dataset.name : null
    };
  }
  /* Configuratia de acum: a configuratorului, daca s-a incarcat (cfg_trackState), altfel cea
     din pagina. */
  function state() {
    if (typeof window.cfg_trackState === 'function') {
      try { return window.cfg_trackState(); } catch (e) {}
    }
    return pagePick();
  }
  function track(name, props, st) {
    var ph = window.posthog, hasPh = ph && typeof ph.capture === 'function';
    if (!hasPh && !window.Ixaria) return;
    var p = (window.IX_PDP && window.IX_PDP.product) || {};
    var out = st || {};
    out.product = p.handle || '';
    out.product_title = p.title || '';
    out.place = 'configurator';
    out.view = 'overlay';
    for (var k in props) if (Object.prototype.hasOwnProperty.call(props, k)) out[k] = props[k];
    if (hasPh) try { ph.capture(name, out); } catch (e) {}
    try { if (window.Ixaria) window.Ixaria.track(name, out); } catch (e) {}
  }
  function trackOpen(t) {
    var source = null;
    for (var s in SOURCE_FOR) {
      if (Object.prototype.hasOwnProperty.call(SOURCE_FOR, s) && t.closest(s)) {
        source = SOURCE_FOR[s];
        break;
      }
    }
    window.ixCfgVisit = { t0: Date.now(), changes: 0 };
    track('ixaria_custom_overlay_opened', { source: source, section: sectionFor(t) }, pagePick());
  }
  function trackClose(ev) {
    var v = window.ixCfgVisit;
    if (!v || v.closed) return;
    v.closed = true;
    var toCart = !!(ev && ev.detail && ev.detail.toCartPage) || !!v.cart;
    track('ixaria_configurator_closed', {
      reason: toCart ? 'add_to_cart' : (ev && ev.type === 'popstate' ? 'back' : 'close'),
      seconds_open: Math.round((Date.now() - v.t0) / 1000),
      changes: v.changes,
      added_to_cart: !!v.cart
    }, state());
  }

  document.addEventListener('ixaria:configurator-close', close);
  window.addEventListener('popstate', close);

  /* Warm it once the page has settled. */
  function schedule() {
    if (!connectionIsCheap()) return;
    if (window.requestIdleCallback) requestIdleCallback(boot, { timeout: 8000 });
    else setTimeout(boot, 3000);
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule);

  /* ── O stare refacuta in configurator ──
     Asteapta motorul si grilele, apoi aplica starea. Initializarea bridge-ului
     si a configuratorului poate rula si dupa ce sunt „gata" si readuce
     forma/culoarea implicite, deci starea se reaplica pana ramane pusa, dar nu
     dupa ce clientul a inceput sa modifice. getState() se citeste la fiecare
     aplicare: null inseamna ca nu mai e nimic de pus. onFirst(pusa) vine o singura
     data: dupa prima aplicare (pusa: chiar era o stare de pus) sau cand nu se mai
     asteapta. */
  function restoreWhenReady(getState, onFirst) {
    var t0 = Date.now();
    (function wait() {
      var ready = typeof window.cfg_restoreState === 'function' &&
        document.querySelector('#ix-cfg #layout-grid [data-layout]') &&
        document.querySelector('#ix-cfg #cfg-fabric-sections .mtile') &&
        (window.FIGARO_API || Date.now() - t0 > 20000);
      if (!ready) {
        if (Date.now() - t0 < 30000) setTimeout(wait, 200);
        else if (onFirst) onFirst(false);
        return;
      }
      var touched = false;
      var mark = function () { touched = true; };
      root.addEventListener('pointerdown', mark, true);
      root.addEventListener('keydown', mark, true);
      var drifted = function (state) {
        var s = window.sel || {};
        return (state.layout && s.layout !== state.layout) ||
          (!state.zoneMode && state.color && s.colorName !== state.color);
      };
      var checks = [600, 1500, 3000, 5000, 8000, 12000];
      checks.forEach(function (ms, i) {
        setTimeout(function () {
          var state = touched ? null : getState();
          if (state && (i === 0 || drifted(state))) {
            window.cfg_restoreState(state);
            if (i > 0) console.info('[ixaria] configuration re-applied after init reset');
          }
          if (i === 0 && onFirst) onFirst(!!state);
          if (i === checks.length - 1) {
            root.removeEventListener('pointerdown', mark, true);
            root.removeEventListener('keydown', mark, true);
          }
        }, ms);
      });
    })();
  }

  /* ── ?ix_edit=<cheia liniei>: linkul vechi din cos ──
     Cosul deschidea cu el configuratorul peste pagina. Acum o linie din cos
     duce mereu la pagina produsului, cu configuratorul inchis (linkul poarta
     forma, culoarea si config). Un cos randat inainte de schimbare mai poate
     avea linkul vechi: parametrul doar se scoate din adresa. */
  function dropCartEditParam() {
    try {
      var u = new URL(location.href);
      if (!u.searchParams.has('ix_edit')) return;
      u.searchParams.delete('ix_edit');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  /* ── Link cu configuratie: ?config=<starea, base64url> ──
     Vine dintr-un link trimis sau copiat (ixaria-pdp.js scrie adresa). Forma si
     culoarea le pune pagina din ?forma= si ?culoare=; aici se reface restul
     (marime, zone, servicii, accesorii), cand configuratorul porneste — pe
     fundal sau la deschidere — fara sa fie deschis de noi. Starea se citeste
     din adresa la fiecare aplicare: daca intre timp clientul a ales alta forma
     sau culoare in pagina, config a fost scos si nu se mai pune nimic peste. */
  function linkState() {
    try {
      var raw = new URLSearchParams(location.search).get('config');
      return raw && typeof window.ixDecodeCfg === 'function' ? window.ixDecodeCfg(raw) : null;
    } catch (e) { return null; }
  }
  /* Configuratia din link pusa in configurator, sau nimic de pus: poza facuta fara
     configurator (ixaria-pdp.js, ixMakeImg) o asteapta, altfel ar fotografia
     canapeaua implicita. */
  var linkApplied = Promise.resolve();
  function configFromLink() {
    if (!linkState()) return;
    linkApplied = new Promise(function (resolve) {
      whenBooted(function () {
        restoreWhenReady(linkState, function (applied) {
          if (applied) console.info('[ixaria] configurator restored from link');
          resolve();
        });
      });
    });
  }

  function fromUrl() {
    dropCartEditParam();
    configFromLink();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromUrl);
  else fromUrl();

  window.IXARIA_CFG_OVERLAY = {
    open: open,
    close: close,
    boot: boot,
    linkApplied: function () { return linkApplied; }
  };
})();
